/**
 * Assert the condition and throw error if assertion failed
 * @param {Boolean} condition Test condition
 * @param {String} message Message about the reason of failed assertion
 */
export var assert = function (condition, message) {
	if (!condition) {
		message = 'Assertion failed: ' + message || 'Assertion failed! See stack trace for details';
		if (typeof Error !== 'undefined') {
			throw new Error(message);
		}
		throw message;
	}
};

/**
 * Get a string listing all object IDs from the provided list
 * @param {Array} objects Array of objects containing the "id" field
 */
export var getIdsString = function (objects) {
	let ids = '';
	for (let i = 0; i < objects.length; i++) ids += objects[i].id + ', ';
	return ids.slice(0, -2); // Remove the last comma and space
};

/**
 * Check if a string is a number
 * @param {String} string The string to be tested
 */
export var isNumber = function (string) {
	if (string.length !== 0 && !Number.isNaN(Number(string))) return true;
	else return false;
};

/**
 * Check if a string is an integer
 * @param {String} string The string to be tested
 */
export var isInteger = function (string) {
	if (string.length !== 0 && !Number.isNaN(Number(string))) {
		let number = Number(string);
		if (Number.isInteger(number)) return true;
		return false;
	}
	return false;
};

/**
 * Clear a string of HTML tags
 * @param {String} html_string Line with html code
 */
export var stripHtml = function (htmlString) {
	return htmlString.replace(/<[^>]+>/g, '');
};

/**
 * Returns a date representation in YYYY-MM-DD HH:MM:SS (UTC+Z) format
 * @param {Date} date The date
 */
export var formatDate = function (date) {
	let _pad = (num, size) => {
		var s = String(num);
		while (s.length < (size || 2)) {
			s = '0' + s;
		}
		return s;
	};
	let result =
		_pad(date.getFullYear()) +
		'-' +
		_pad(date.getMonth()) +
		'-' +
		_pad(date.getDate()) +
		' ' +
		_pad(date.getHours()) +
		':' +
		_pad(date.getMinutes()) +
		':' +
		_pad(date.getSeconds()) +
		' (UTC' +
		date.getTimezoneOffset() / 60 +
		')';
	return result;
};

/**
 * Checks whether the property with the specified name is of type 'object' or null
 */
const _object_or_null_check = (props, propName, componentName) => {
	const propValue = props[propName];
	if (propValue === null) return;
	if (typeof propValue === 'object') return;
	return new Error(`The prop '${propName}' of '${componentName}' only accepts object or null`);
};

/**
 * Custom PropType's for checking component property types
 */
export const PropTypesCustom = {
	object_or_null: _object_or_null_check,
	object_or_null_required: (props, propName, componentName) => {
		if (!(propName in props))
			return new Error(
				`The prop '${propName}' is marked as required in '${componentName}', but its value is 'undefined'`
			);
		return _object_or_null_check(props, propName, componentName);
	},
};

/**
 * Download as file
 * @param {String} filename Filename that will be suggested
 * @param {String} content File content
 */
export var download = function (filename, content) {
	let element = document.createElement('a');
	element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
	element.setAttribute('download', filename);
	element.style.display = 'none';
	document.body.appendChild(element);
	element.click();
	document.body.removeChild(element);
};

/**
 * Prepare price block from database value
 * @param {String} price    Card price from database
 * @returns {String}        Processed price
 */
export var parsePrice = function (price, available) {
	if (available === false) return <span className="price na">N/A</span>;
	if (price === '0.00') return <span className="price">?</span>;
	return (
		<span className="price">
			<span className="usd">$</span>&thinsp;
			<span className="value">{price}</span>
		</span>
	);
};
